import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  /**
   * regex part of string and wraps a span around. Will match accents as well.
   * @param value string to modify
   * @param needle part of string you want to wrap in a span (global)
   * @param css optional class for span. highlight is default
   */
  transform(value: string, needle: string, css = 'highlight'): string {
    const regexp = new RegExp(
      this.escapeRegExp(needle.normalize('NFD').replace(/[\u0300-\u036f]/g, '')),
      'gi'
    );
    const strippedText = value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(regexp, '<%%%%>$&</%%%%>');
    const starts = this.findAll(strippedText, '<%%%%>');
    const ends = this.findAll(strippedText, '</%%%%>');
    for (let i = 0; i < starts.length; i++) {
      value = this.splice(value, starts[i], 0, '<span>');
      value = this.splice(value, ends[i], 0, '</span>');
    }
    return value.replace(/<span>/g, '<span class="' + css + '">');
  }

  private splice(str: string, start: number, delCount: number, newSubStr: string): string {
    return str.slice(0, start) + newSubStr + str.slice(start + Math.abs(delCount));
  }

  private findAll(str: string, substr: string): Array<number> {
    const a = [];
    let i = -1;
    while ((i = str.indexOf(substr, i + 1)) >= 0) {
      a.push(i);
    }
    return a;
  }

  private escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
